<template>
  <div class="parkStatistic">
    <div class="bg-light pd-shadow p-bg">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/main' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/classTeacherList' }">班主任列表</el-breadcrumb-item>
        <el-breadcrumb-item>带班信息</el-breadcrumb-item>
        <el-breadcrumb-item>家庭自评班级统计信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="un-content" v-loading="loading">
      <div class="p-bg">
        <div class="bg-fff p-sm search-box pd-shadow">

          <el-row :gutter="24">
            <el-col :span="6" :md="6" :sm="8" class="">
              <div class='search-item'>
                <label class="name">查询时间：</label>
                <div class="items-box">
                  <el-date-picker v-model="params.statisticsDay" type="month" value-format="yyyy-MM" class="search-item-picker" size="small" placeholder="开始日期"></el-date-picker>
                </div>
              </div>
            </el-col>
            <el-col :span="18">
              <div class="flex flex-end">
                <div>
                  <el-button type="primary" icon="el-icon-search" size="small" @click="getListAction()">查询</el-button>
                  <el-button type="success" size="small" icon="el-icon-download" @click="downLoad">导出</el-button>
                </div>
                <el-button @click="$router.back()" size="small" type="text" class="color-info" icon="el-icon-arrow-left ">返回 </el-button>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="p-lrbg">
        <div class="bg-fff pd-shadow clearfix table-box" v-loading="loading">
          <h1 class="title">{{listData.evaluateBaseVO.className}} 学生家庭习惯统计（学生家长自评）</h1>
          <table class="table-bordered table table-striped" v-if="isFrist">
            <thead>
              <tr class="background-FAFAFA">
                <td>学号</td>
                <td>姓名</td>
                <template v-for="item in listData.evaluateTypeList">
                  <td :key="item.evaluateTypeCode">{{item.evaluateTypeName}}</td>
                </template>
                <td>本周得分</td>
                <td>已评/未评</td>
                <td>姓名</td>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item,index) in listData.studentList">
                <tr :class="index%2 == 0 ? '':'background-FAFAFA'" :key="index">
                  <td>{{item.xh}}</td>
                  <td>{{item.name}}</td>
                  <template v-if="item.evaluateTypeList">
                    <template v-for="(itemObj,key) in item.evaluateTypeList">
                      <td :key="item.xh+key">{{itemObj.starScore}}</td>
                    </template>
                  </template>
                  <td>{{item.weekScore}}</td>
                  <td>{{item.hasEvaluate == 1 ? '<span class="color-success">已评</span>' :'<span class="color-error">未评</span>'}}</td>
                  <td>{{item.avgScore}}</td>
                </tr>
              </template>
              <tr v-if="!listData.studentList">
                <td :colspan="listData.evaluateTypeList.length +5">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "classTeacherEvaluateInfo",
  components: {},
  data() {
    return {
      listData: {
        evaluateBaseVO: {}
      },
      isFrist: false,
      total: 0,
      loading: true,
      termLoading: false,
      selectLoading: false,
      params: {
        statisticsDay: "",
        classId: this.$route.query.id
      }
    };
  },
  created() {
    this.getListAction();
  },
  methods: {
    //导出
    downLoad() {
      window.open(
        this.$api.fileApi.exportDownLoad("JTZPExport", {
          classId: this.params.classId,
          statisticsDay: this.params.statisticsDay
        })
      );
    },
    // 获取列表数据
    getListAction() {
      this.loading = true;
      this.$http
        .post(this.$api.manageApi.getEvaluateClassList(), this.params)
        .then(res => {
          this.loading = false;
          this.isFrist = true;
          this.listData = res.data;
          this.total = res.data.totalCount;
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.title {
  padding: 20px;
  text-align: center;
}
.table-box {
  overflow: auto;
      padding:0 12px;
}
.courseStatistic {
  .el-cascader {
    width: 100%;
  }
}
.top-sc {
  text-align: right;
}
.search-row {
  margin-bottom: 10px;
  .label-title {
    line-height: 32px;
    font-size: 12px;
  }
}
</style>
